import { Box, styled } from '@driftt/dds'

export const OnboardingShepherdContainer = styled(Box, {
  '.shepherd-button.secondary': {
    backgroundColor: '$primary'
  }
})
